import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useSaveBrandsForInvestment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      investingService.saveBrandsForInvestment(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.setQueryData(
            [QUERY_KEYS.investing.investment_brands, 'review'],
            () => data,
          );
          return data;
        }
        const error = new Error(data?.message);
        error.code = data?.error?.code;
        throw error;
      }),
  });
};
